import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { graphqlProviders } from './graphql.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { LoginApiEffects } from 'src/shared/components/login/ngrx/login-api.effects';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FavoriteReducer } from 'src/shared/components/map/ngrx/map.reducer';
import { StoreModule } from '@ngrx/store';
import { NgxMaskModule } from 'ngx-mask';
import { provideNativeDateAdapter } from '@angular/material/core';
import { FEATURE_KEY, metaReducers, reducers } from 'src/shared/state';
import { definePreset } from '@primeuix/themes';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// Padronização das cores do primeng
const MyCustomPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#f5f7ff',
      100: '#cce9dec7',
      200: '#cce9dec7',
      300: '#cce9dec7',
      400: '#cce9dec7',
      500: '#008e58', // Cor principal padrão (Fundo de botões, etc.)
      600: '#006f47', // Cor para o hover do botão
      700: '#006f47', // Cor para o estado Active/Selecionado
      800: '#035034',
      900: '#035034',
      950: '#035034',
    },
  },
});
export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideNativeDateAdapter(),
    provideRouter(routes),
    providePrimeNG({
      theme: {
        preset: MyCustomPreset,
        options: {
          darkModeSelector: false || 'none',
        },
      },

      translation: {
        firstDayOfWeek: 0,
        dayNames: [
          'Domingo',
          'Segunda-feira',
          'Terça-feira',
          'Quarta-feira',
          'Quinta-feira',
          'Sexta-feira',
          'Sábado',
        ],
        dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
        dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
        monthNames: [
          'Janeiro',
          'Fevereiro',
          'Março',
          'Abril',
          'Maio',
          'Junho',
          'Julho',
          'Agosto',
          'Setembro',
          'Outubro',
          'Novembro',
          'Dezembro',
        ],
        monthNamesShort: [
          'jan',
          'fev',
          'mar',
          'abr',
          'mai',
          'jun',
          'jul',
          'ago',
          'set',
          'out',
          'nov',
          'dez',
        ],
        today: 'Hoje',
        clear: 'Limpar',
      },
    }),

    provideHttpClient(withInterceptorsFromDi()),
    ...graphqlProviders,

    importProvidersFrom(),

    importProvidersFrom(
      NgbModule,
      StoreModule.forFeature(FEATURE_KEY, reducers, { metaReducers }),
      StoreModule.forRoot({ favorite: FavoriteReducer }),
      StoreDevtoolsModule.instrument({ maxAge: 15 }),
      EffectsModule.forRoot([]),
      NgxMaskModule.forRoot(),
      EffectsModule.forFeature([LoginApiEffects]),
      TranslateModule.forRoot({
        defaultLanguage: 'pt',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
  ],
};
